import { AuthSpec, type PageType, type ActionTypeMap } from './auth.defines';
import { isRoleIdIncluded } from './auth.utils';
import { useMyInfoStore } from '@/config/stores/my-info';

const useAuthorize = <P extends PageType>(pageType: P, actionType: ActionTypeMap[P]) => {
  const { role: roleId } = useMyInfoStore().myInfo;
  const allowedRoles = AuthSpec[pageType][actionType];

  return isRoleIdIncluded(allowedRoles, roleId);
};

export default useAuthorize;
